import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { NotificationServiceNew } from '../_services/notification.service';
@Injectable()
export class SuccessInterceptor implements HttpInterceptor {
    constructor(
        private notificationService: NotificationServiceNew,
    ) { }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler,
    ): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(
            tap(evt => {
                if (evt instanceof HttpResponse) {
                    if (evt.headers.get('message')) {
                        this.notificationService.showSuccess(evt.headers.get('message'), 'Success');
                    }
                }
            }),
        );
    }
}
